// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://assets.foursightonline.com/app/fonts/webfonts/webfonts.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fs-slideshow {
  padding: 40px;
}
@media only screen and (max-width: 991px) {
  .fs-slideshow {
    padding: 20px;
  }
}

.all-learner-maps ::ng-deep .wrapper-learner-map {
  width: 100%;
}
@media (max-width: 991px) {
  .all-learner-maps ::ng-deep .wrapper-learner-map .wrap-all-boxes {
    padding-inline: 20px;
  }
}
.all-learner-maps ::ng-deep .wrapper-learner-map > .wrapper {
  padding: 0;
  margin-inline: auto;
}
::ng-deep .all-learner-maps.presnter-lm {
  padding: 60px 20px;
  clear: both;
  float: left;
  width: 100%;
  display: flex;
  justify-content: center;
}
::ng-deep .all-learner-maps.presnter-lm .wrapper-learner-map--cnc {
  width: 100%;
  display: block;
}
::ng-deep .all-learner-maps.presnter-lm .wrapper-learner-map--cnc .wrap-all-boxes {
  max-width: unset !important;
}
::ng-deep .all-learner-maps.presnter-lm.card-view {
  display: block;
}
::ng-deep .all-learner-maps.presnter-lm__flx {
  display: none;
}
::ng-deep .all-learner-maps.presnter-lm .wrapper-content {
  padding: 20px 10px 40px;
  clear: both;
  float: left;
  width: 100%;
  background: #fff;
}
::ng-deep .all-learner-maps.presnter-lm .wrapper-content--tst {
  width: 100% !important;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .all-learner-maps.presnter-lm {
    padding: 30px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .all-learner-maps.presnter-lm {
    padding: 20px 20px 40px;
  }
}
.all-learner-maps.lm-an-cards {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  position: relative;
}
.all-learner-maps.lm-an-cards .product-imitation {
  background-color: #fff;
  color: #676a6c;
}
.all-learner-maps .lm-an-cards__print {
  position: absolute;
  right: 16px;
  top: -42px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  background: #06AED0;
  color: #fff;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s;
}
.all-learner-maps .lm-an-cards__print:hover {
  background: #058da8;
}
.all-learner-maps .lm-an-cards__print i {
  font-size: 14px;
}
@media (max-width: 991px) {
  .all-learner-maps .lm-an-cards__print {
    right: 20px;
    padding: 6px 12px;
    font-size: 12px;
  }
}
.all-learner-maps .car-small-heading {
  color: #fff;
}
.all-learner-maps .practioner-dash-wrap--ss {
  background: #F1F1F2;
  border-radius: 8px;
  color: #fff;
  padding: 30px 24px;
}
@media (max-width: 767px) {
  .all-learner-maps .practioner-dash-wrap--ss {
    padding: 20px 16px;
  }
}
.all-learner-maps ::ng-deep.start-work__cell .product-imitation {
  background-color: #fff;
  color: #676a6c;
}

.loader-container {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  background: rgba(236, 236, 236, 0.9);
  display: -ms-flexbox;
  display: none;
  justify-content: center;
  align-items: center;
  z-index: 9999999999;
  height: 100vh;
  margin: 0 auto;
}

.loader-spin {
  background-color: hsla(0, 0%, 92.5%, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.loader__inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#Path_129 {
  animation: blink 2s linear infinite;
  opacity: 0;
}

#Path_130 {
  animation: blink 2s linear infinite;
  animation-delay: 0.5s;
  opacity: 0;
}

#Path_132 {
  animation: blink 2s linear infinite;
  animation-delay: 1s;
  opacity: 0;
}

#Path_131 {
  animation: blink 2s linear infinite;
  animation-delay: 1.5s;
  opacity: 0;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.lm-slide-view {
  padding-top: 20px;
}

.presnter-lm {
  display: block;
}
.presnter-lm__flx {
  display: none;
}
.presnter-lm .map-heading {
  margin-top: 0;
}
.presnter-lm .wrap-all-boxes {
  display: block;
  max-width: 710px;
  margin: 0 auto 50px;
}
.presnter-lm .wrap-all-boxes--ccltst {
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/fs-slideshow/fs-slideshow.component.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;AAAF;AAEE;EAHF;IAII,aAAA;EACF;AACF;;AAMI;EACE,WAAA;AAHN;AASQ;EAJF;IAKI,oBAAA;EANR;AACF;AASM;EACE,UAAA;EAEA,mBAAA;AARR;AAcE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AAZJ;AAgBM;EACE,WAAA;EACA,cAAA;AAdR;AAgBQ;EACE,2BAAA;AAdV;AAmBI;EACE,cAAA;AAjBN;AAoBI;EACE,aAAA;AAlBN;AAqBI;EACE,uBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;AAnBN;AAqBM;EACE,sBAAA;AAnBR;AA0BI;EA3CF;IA4CI,aAAA;EAvBJ;AACF;AAyBI;EA/CF;IAgDI,uBAAA;EAtBJ;AACF;AAyBE;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAvBJ;AAyBI;EACE,sBAAA;EACA,cAAA;AAvBN;AA2BE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;AAzBJ;AA2BI;EACE,mBAAA;AAzBN;AA4BI;EACE,eAAA;AA1BN;AA6BI;EA3BF;IA4BI,WAAA;IACA,iBAAA;IACA,eAAA;EA1BJ;AACF;AA6BE;EACE,WAAA;AA3BJ;AA8BE;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AA5BJ;AA8BI;EANF;IAOI,kBAAA;EA3BJ;AACF;AAgCI;EACE,sBAAA;EACA,cAAA;AA9BN;;AAoCA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EAEA,oBAAA;EACA,aAAA;EAGA,uBAAA;EAGA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AAjCF;;AAoCA;EACE,yCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;AAjCF;;AAoCA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AAjCF;;AAqCA;EACE,mCAAA;EACA,UAAA;AAlCF;;AAqCA;EACE,mCAAA;EACA,qBAAA;EACA,UAAA;AAlCF;;AAqCA;EACE,mCAAA;EACA,mBAAA;EACA,UAAA;AAlCF;;AAqCA;EACE,mCAAA;EACA,qBAAA;EACA,UAAA;AAlCF;;AAqCA;EACE;IACE,UAAA;EAlCF;EAqCA;IACE,UAAA;EAnCF;EAsCA;IACE,UAAA;EApCF;AACF;AAwCA;EACE,iBAAA;AAtCF;;AA2CA;EACE,cAAA;AAxCF;AA0CE;EACE,aAAA;AAxCJ;AA2CE;EACE,aAAA;AAzCJ;AA4CE;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;AA1CJ;AA4CI;EACE,eAAA;AA1CN","sourcesContent":["@import url('https://assets.foursightonline.com/app/fonts/webfonts/webfonts.css');\n\n.fs-slideshow {\n  padding: 40px;\n\n  @media only screen and (max-width:991px) {\n    padding: 20px;\n  }\n}\n\n.all-learner-maps {\n\n  ::ng-deep {\n\n    .wrapper-learner-map {\n      width: 100%;\n\n      .wrap-all-boxes {\n        // width: min(976px , 100%);\n        // padding: 40px;\n\n        @media (max-width: 991px) {\n          padding-inline: 20px;\n        }\n      }\n\n      & > .wrapper {\n        padding: 0;        \n        // width: min(976px , 100%);\n        margin-inline: auto;\n      }\n    }\n    \n  }\n\n  ::ng-deep &.presnter-lm {\n    padding: 60px 20px;\n    clear: both;\n    float: left;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n\n    .wrapper-learner-map {\n\n      &--cnc {\n        width: 100%;\n        display: block;\n\n        .wrap-all-boxes {\n          max-width: unset !important;\n        }\n      }\n    }\n\n    &.card-view {\n      display: block;\n    }\n\n    &__flx {\n      display: none;\n    }\n\n    .wrapper-content {\n      padding: 20px 10px 40px;\n      clear: both;\n      float: left;\n      width: 100%;\n      background: #fff;\n\n      &--tst {\n        width: 100% !important;\n      }\n    }\n\n    // Card styles are in global styles.scss scoped to .all-learner-maps.presnter-lm\n    // to bypass Angular view encapsulation\n\n    @media only screen and (max-width:991px) {\n      padding: 30px;\n    }\n\n    @media only screen and (max-width:767px) {\n      padding: 20px 20px 40px;\n    }\n  }\n\n  &.lm-an-cards {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    position: relative;\n\n    .product-imitation {\n      background-color: #fff;\n      color: #676a6c;\n    }\n  }\n\n  .lm-an-cards__print {\n    position: absolute;\n    right: 16px;\n    top: -42px;\n    z-index: 2;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 16px;\n    font-size: 13px;\n    font-weight: 600;\n    border-radius: 6px;\n    background: #06AED0;\n    color: #fff;\n    border: none;\n    cursor: pointer;\n    white-space: nowrap;\n    transition: background 0.2s;\n\n    &:hover {\n      background: darken(#06AED0, 8%);\n    }\n\n    i {\n      font-size: 14px;\n    }\n\n    @media (max-width: 991px) {\n      right: 20px;\n      padding: 6px 12px;\n      font-size: 12px;\n    }\n  }\n\n  .car-small-heading {\n    color: #fff;\n  }\n\n  .practioner-dash-wrap--ss {\n    background: #F1F1F2;\n    border-radius: 8px;\n    color: #fff;\n    padding: 30px 24px;\n\n    @media (max-width: 767px) {\n      padding: 20px 16px;\n    }\n  }\n\n  ::ng-deep.start-work__cell {\n\n    .product-imitation {\n      background-color: #fff;\n      color: #676a6c;\n    }\n  }\n}\n\n\n.loader-container {\n  position: absolute;\n  left: 0;\n  right: 0;\n  text-align: center;\n  top: 0;\n  bottom: 0;\n  background: rgba(236, 236, 236, .9);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: none;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  z-index: 9999999999;\n  height: 100vh;\n  margin: 0 auto;\n}\n\n.loader-spin {\n  background-color: hsla(0, 0%, 92.5%, .9);\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.loader__inner {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n\n}\n\n#Path_129 {\n  animation: blink 2s linear infinite;\n  opacity: 0;\n}\n\n#Path_130 {\n  animation: blink 2s linear infinite;\n  animation-delay: .5s;\n  opacity: 0;\n}\n\n#Path_132 {\n  animation: blink 2s linear infinite;\n  animation-delay: 1s;\n  opacity: 0;\n}\n\n#Path_131 {\n  animation: blink 2s linear infinite;\n  animation-delay: 1.5s;\n  opacity: 0;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n\n}\n\n.lm-slide-view {\n  padding-top: 20px;\n}\n\n\n// Legacy support\n.presnter-lm {\n  display: block;\n\n  &__flx {\n    display: none;\n  }\n\n  .map-heading {\n    margin-top: 0;\n  }\n\n  .wrap-all-boxes {\n    display: block;\n    max-width: 710px;\n    margin: 0 auto 50px;\n\n    &--ccltst {\n      max-width: 100%;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
